import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';

@Component({
    selector: 'app-features-page',
    imports: [
        CommonModule,
        SharedModule
    ],
    templateUrl: './features-page.component.html',
    styleUrls: ['./features-page.component.css']
})
export class FeaturesPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
